import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { catalogueSagaActions } from "..";

import { Button, Card, Carousel, Row } from "react-bootstrap";

import { ArrowLeftCircleFill, ArrowRightCircleFill } from "react-bootstrap-icons";

import catalogStyles from "../css/Catalogue.module.css";
import carouselStyles from "../css/Carousel.module.css";
import "../css/Generic.css";

export const RegionCatalogueCarousel = ({ regions, regionTotalCount }) => {

  const history = useHistory();

  const dispatch = useDispatch();

  let columnCardsCount = 8; //set this to the number cards to be displayed in earch carousel item

  let dummyArray = Array(Math.ceil(regionTotalCount / columnCardsCount)).fill(0);

  const handleRegionSelection = (region) => {

    dispatch(catalogueSagaActions.setRegion(region));

    history.push({ pathname: "/catalogue-management/provinces", state: { region } });
  };

  return (
    <Carousel
      prevIcon={<ArrowLeftCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} />}
      nextIcon={<ArrowRightCircleFill className={catalogStyles.carouselNavButton} color="#999" size={40} />}
      controls={regionTotalCount > columnCardsCount ? true : false}
      indicators={true}
      interval={null} /* set to null to stop carousel from cycling */
    >

      {dummyArray.map((val, y) =>
        <Carousel.Item key={"yyy_" + y}>
          <Row>
            {regions.slice(((y) * columnCardsCount), ((y + 1) * columnCardsCount)).map((region, z) =>
                <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex" key={"zzz_" + z}>
                <Card className={`${carouselStyles.carouselCard} w-100 mb-10`}>
                  <Card.Img
                    variant="top"
                    src={region ? `../media/flags/${region.name}.jpg` : "../media/flags/flag_PNG.svg"}
                    style={{ width: '100%', height: '55%' }}
                  />
                  <Card.Body className={`${carouselStyles.cardBody}`}>
                    <Card.Title><span style={{ fontSize: "1.2rem" }}>{region.name}</span></Card.Title>
                    {/* <Card.Text>
                        <span style={{fontSize:"1rem", display:"block"}}>View Government services available in this province.</span>
                      </Card.Text> */}
                    <Button variant="primary" className={`${carouselStyles.cardBodyButton}`} onClick={() => handleRegionSelection(region)}>View Provinces</Button>
                  </Card.Body>
                </Card>
              </div>
            )}
          </Row>
        </Carousel.Item>
      )}
    </Carousel>
  );
};
